import { render, staticRenderFns } from "./MailSendForm.vue?vue&type=template&id=d0bb49ca&"
import script from "./MailSendForm.vue?vue&type=script&lang=js&"
export * from "./MailSendForm.vue?vue&type=script&lang=js&"
import style0 from "./MailSendForm.vue?vue&type=style&index=0&id=d0bb49ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports